import React from 'react'
import NavBar from '../components/NavBar';
import Footer from '../components/Footer';
import PopInRightPanel from '../components/PopInRightPanel';
import ObservationTable from '../components/ObservationTable';

function Observations() {
  return (
    <>
    <main className="main-content border-radius-lg ">
    <NavBar/>   
    <ObservationTable/>
    <Footer/>
    </main>
    <PopInRightPanel/>
    </>
  )
}

export default Observations
